import { motion } from "framer-motion";
import { ChevronDown, Award, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function HeroSection() {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="home"
      className="hero-bg min-h-screen flex items-center justify-center relative grain-overlay"
      data-testid="hero-section"
    >
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          {/* Badges */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            <span className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium">
              <CheckCircle className="w-4 h-4" />
              NHB Registered
            </span>
            <span className="inline-flex items-center gap-2 bg-[#E07A5F]/90 text-white px-4 py-2 rounded-full text-sm font-medium award-badge">
              <Award className="w-4 h-4" />
              ASM Udhyan Ratna 2024
            </span>
          </div>

          {/* Main Heading */}
          <h1
            className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight tracking-tight"
            style={{ fontFamily: "'Fraunces', serif" }}
          >
            Kishan Coconut Nursery
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-white/90 mb-4 max-w-2xl mx-auto leading-relaxed">
            Premium Hybrid Coconut Seedlings for Quality-Conscious Farmers
          </p>

          {/* Location */}
          <p className="text-white/70 text-sm mb-10">
            Village Supasi, Taluka Veraval, District Gir Somnath, Gujarat – 362255
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => scrollToSection("#products")}
              className="bg-white text-[#2F5233] hover:bg-white/90 rounded-full px-8 py-6 text-lg font-medium btn-scale shadow-lg"
              data-testid="hero-explore-btn"
            >
              Explore Seedlings
            </Button>
            <Button
              onClick={() => scrollToSection("#contact")}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white/10 rounded-full px-8 py-6 text-lg font-medium btn-scale"
              data-testid="hero-contact-btn"
            >
              Contact Us
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="absolute bottom-8 left-1/2 scroll-indicator"
      >
        <a
          href="#about"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#about");
          }}
          className="flex flex-col items-center text-white/70 hover:text-white transition-colors"
          data-testid="scroll-indicator"
        >
          <span className="text-xs mb-2 uppercase tracking-widest">Scroll</span>
          <ChevronDown className="w-5 h-5" />
        </a>
      </motion.div>
    </section>
  );
}
